import AES from 'crypto-js/aes';
import CryptoJS from 'crypto-js';
import moment from 'moment';
import Logo from '../../src/assets/common/static/img/favicon.png';
import {
  COMMON_CONST,
  SUCCESS_RESPONSE,
  DEFAULT_FILE_NAME,
  UNSET_DEFAULT_VALUE,
  VERSION_CONFIG,
} from '../constants/constants';

/**
 * 判断变量是否为对象
 * @param {*} obj
 * @returns
 */
export const isObject = (obj) => {
  return obj !== undefined && obj !== null && obj.constructor === Object
}

export function isEmpty(value) {
  return value === undefined || value === null || value === '';
}

export function isEmptyObject(obj) {
  if (obj !== null && obj !== undefined) return Object.keys(obj).length === 0;
  return true;
}

export function isFormData(value) {
  return value instanceof FormData;
}

export function wait(timeout) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, timeout);
  });
}

export function aesCbcEncryptPskc(value, key) {
  const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');
  const encrypted = CryptoJS.AES.encrypt(
    value,
    CryptoJS.enc.Hex.parse(key.toString()),
    {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    },
  );
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
}

export function createKeyShaPassword(password, salt, verifyCode) {
  const hexSHA1String = CryptoJS.SHA1(password + salt).toString(
    CryptoJS.enc.Hex,
  );
  return CryptoJS.SHA256(hexSHA1String + verifyCode);
}

export function hashPassword(password, salt, verifyCode) {
  const key = createKeyShaPassword(password, salt, verifyCode);
  return aesCbcEncryptPskc(password, key);
}

export function aesCbcEncrypt(value, key) {
  const sks = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Hex.parse('0'.repeat(16));
  const length = 16 - (value.length % 16);
  const content = value + ' '.repeat(length);
  const encrypted = AES.encrypt(content, sks, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.NoPadding,
    iv,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Hex).toUpperCase();
}

export function isSuccess(response) {
  return response && response.result === SUCCESS_RESPONSE;
}

export function getParameterByName(rawName, rawUrl) {
  let url = rawUrl;
  if (!rawUrl) {
    url = window.location.href;
  }
  const name = rawName.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function validateEmail(email) {
  if (!isEmpty(email)) {
    // eslint-disable-next-line max-len
    const re = /^[a-zA-Z0-9.]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return re.test(String(email).toLowerCase());
  }
  return true;
}

export function genNonce() {
  const charset =
    '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
  const result = [];
  window.crypto
    .getRandomValues(new Uint8Array(32))
    .forEach(c => result.push(charset[c % charset.length]));
  return result.join('');
}

export function formatCurrency(
  value,
  unit = CONFIG.CURRENCY_SYMBOL,
  locale = CONFIG.LOCALE_FORMAT,
  digit = 0,
) {
  const v = parseFloat(value).toLocaleString(locale, {
    minimumFractionDigits: digit,
  });
  if (CONFIG.VER === VERSION_CONFIG.TH) {
    return unit ? `${unit}${v}` : `${v}`;
  }
  return unit ? `${v}${unit}` : `${v}`;
}

export function getDate(offset = 0) {
  return moment()
    .add(offset, 'days')
    .toDate();
}

export function parseDate(date) {
  return moment(date, COMMON_CONST.FormatDate).toDate();
}

export function formatDate(date) {
  return moment(date).format(COMMON_CONST.FormatDate);
}

export function parseDateTime(date) {
  return moment(date, COMMON_CONST.FormatDateTime).toDate();
}

export function formatDateView(date) {
  return moment(date).format(COMMON_CONST.FormatDayView);
}

export function formatDateTime(date) {
  return moment(date).format(COMMON_CONST.FormatDateTime);
}

export function formatDateTimeView(date) {
  return moment(date).format(COMMON_CONST.FormatDateView);
}

export function formatTimeDateView(date) {
  return moment(date).format(COMMON_CONST.FormatTimeDateView);
}

export function formatStartDateTime(date) {
  return moment(date)
    .startOf('day')
    .format(COMMON_CONST.FormatDateTime);
}

export function formatEndDateTime(date) {
  return moment(date)
    .endOf('day')
    .format(COMMON_CONST.FormatDateTime);
}

export function formatTSTimeDateView(date) {
  return moment.unix(date).format(COMMON_CONST.FormatTimeDateView);
}

// Set time (format HH:mm:ss|HH:mm) and keep the date
export function setTime(date, timeString) {
  const [hour, minute, second = 0] = timeString.split(':');
  return moment(date)
    .set({ hour, minute, second })
    .toDate();
}

export function parseToInt(value) {
  return parseInt(value, 10);
}

export function mathRoundNumber(value) {
  return Math.round(value);
}

export function getIdsPaging(itemIds, activePage, pageSize) {
  const pageIndex = activePage - 1;
  return !isEmpty(itemIds)
    ? itemIds.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize)
    : [];
}

export function getIdsPagingMaps(itemList, activePage, pageSize) {
  const itemIds = !isEmpty(itemList) ? Array.from(itemList.keys()) : [];
  return getIdsPaging(itemIds, activePage, pageSize);
}

export function numberToArray(count, start = 1) {
  return [...Array(count - start).keys()].map(item => item + start);
}

export function decodeUtf8(arrayBuffer) {
  return new TextDecoder('utf-8').decode(arrayBuffer);
}

export async function requestNotificationPermission() {
  // Check if the browser supports notifications
  if ('Notification' in window && Notification.permission !== 'denied') {
    return Notification.requestPermission();
  }
  return 'denied';
}

export async function sendNotify({ message, icon = Logo, detail }) {
  // Check if the browser supports notifications
  if ('Notification' in window) {
    const createNotification = () => {
      const notification = new Notification(message, {
        body: detail,
        icon,
        tag: 'uniqueTag',
      });
      notification.onclick = () => {
        window.focus();
        notification.close();
      };
      setTimeout(notification.close.bind(notification), 4000);
    };

    if (Notification.permission === 'granted') {
      createNotification();
    } else if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        createNotification();
      }
    }
  }
}

export function isAllowNotification() {
  return Notification.permission !== 'denied';
}
// if permission is granted -> current position
// else return default location
export function getCurrentLocation(
  defaultLocation = { lat: 10.7779631, lng: 106.6877743 },
) {
  if ('geolocation' in navigator) {
    return new Promise(resolve => {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude: lat, longitude: lng } = position.coords;
          resolve({ lat, lng });
        },
        () => resolve(defaultLocation),
        { enableHighAccuracy: true, maximumAge: 30000, timeout: 27000 },
      );
    });
  }
  return Promise.resolve(defaultLocation);
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function roundedDistance(distance) {
  let firstPart = parseToInt(distance / 100);
  const secondPart = distance % 100;
  if (secondPart >= 50) {
    firstPart += 1;
  }
  return firstPart * 100;
}

export function removeParamsForServer(
  requestData,
  paramRemove = UNSET_DEFAULT_VALUE,
) {
  return Object.keys(requestData).reduce((validObject, key) => {
    if (isEmpty(requestData[key]) || requestData[key] === paramRemove) {
      return validObject;
    }
    return {
      ...validObject,
      [key]: requestData[key],
    };
  }, {});
}

export function validatePhone(phone) {
  if (CONFIG.VER === VERSION_CONFIG.Th) {
    const phoneRegTh = /^0[0-9]{8,9}$/;
    return phoneRegTh.test(phone);
  }
  const phoneRegVN = /^0[0-9]{9,10}$/;
  return phoneRegVN.test(phone);
}

export function clearSpecialCharacters(value = '') {
  return value.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
}

export function getLocalStore(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function setLocalStore(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function copyTextToClipboard(text) {
  window.navigator.clipboard.writeText(text);
}

export function isMatchText(text, pattern) {
  const normalizeText = String(text)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const normalizePattern = String(pattern)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  return normalizeText.includes(normalizePattern);
}

export function coverText(dumpText, lastLimit = 4, letter = '*') {
  const text = String(dumpText);
  return text.substr(-lastLimit).padStart(text.length, letter);
}

export function getPermissionRestaurant(restaurants, role) {
  return restaurants.filter(item => item.user_permission_flag & role);
}

export function downloadFileExport(fileUrl, fileName = DEFAULT_FILE_NAME) {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.style = 'display: none';
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function convertPriceToValue(value = '', removeParam = 'đ') {
  return mathRoundNumber(value.replace(/[,đ,$]/g, '').replace(removeParam, ''));
}

export function getReactSelectValue(availableOptions, currentVal) {
  return availableOptions.find(option => option.value === currentVal);
}



// WEBPACK FOOTER //
// ./foody/src/utils/utils.js